import * as React from 'react'
import styled from 'styled-components'
import useLazyImageSrc from 'hooks/useLazyImageSrc'
import Link from 'theme/atoms/Link'
import Markdown from 'theme/atoms/Markdown'
import { Props } from './types'
import useInView from 'hooks/useInView'
import * as actions from './actions'

let isAdmin = false
if (typeof window !== 'undefined') {
  // @ts-ignore
  isAdmin = window.document.isStorybook || false
}

export default function ImageWithLinks(props: Props) {
  const [ref, image] = useLazyImageSrc(
    props.context.optImg,
    props.context.base64,
    100,
  )
  const [wrapperRef, inView] = useInView()
  const wasInView = React.useRef(false)

  React.useEffect(() => {
    if (inView && !wasInView.current) {
      wasInView.current = true
      props.eecTrack && actions.scrollIntoView(props)
    }
  }, [inView, props])

  const handleClick = () => props.eecTrack && actions.click(props)
  
  return (
    <Wrapper ref={wrapperRef} className="ImageWithLinks" onClick={handleClick}>
      <div className="image-wrapper">
        <img ref={ref} src={image} alt={props.alt} />
        {props.links.map((link) => (
          <AbsoluteLink key={link.to} {...link} />
        ))}
      </div>
      {props.label && (
        <div className="description">
          <Markdown centered children={props.label} />
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > .image-wrapper {
    width: 100%;
    position: relative;
    > img {
      width: 100%;
      display: block;
    }
  }
  > .description {
    p {
      margin: 0;
      font-size: 14px !important;
    }
  }
`

const AbsoluteLink = styled(Link).attrs((props) => ({
  style: {
    top: props.y / 10 + '%',
    left: props.x / 10 + '%',
    width: props.w / 10 + '%',
    height: props.h / 10 + '%',
  },
}))`
  background: ${isAdmin ? 'rgba(0,0,0, 0.5)' : 'none'};
  position: absolute;
`
